import { ref, watchEffect } from 'vue'
import { projectFirestore } from '../firebase/config'

const getPosts = (collection, query) => {
  const posts = ref(null);// 放posts
  const error = ref(null);
  let collectionRef = projectFirestore.collection(collection).orderBy('createdAt')
  if(query) {
    collectionRef = collectionRef.where(...query);
  }
  const unsub = collectionRef.onSnapshot(snap => {
    let results= [];
    snap.docs.forEach(doc => {
      doc.data().createdAt && results.push({ ...doc.data(), id: doc.id })
    })
    posts.value = results;
    error.value = null
  }, err => {
    posts.value = null;
    error.value = 'could not fetch the data'
    console.log(err.message)
  });
  /* const load = async () => {  // 非同步function取資料
     // 若是promise錯誤，則會跑catch，成功則不會跑catch
        let data = await projectFirestore.collection('posts')
        .orderBy('createdAt','desc')
        const unsub = collectionRef.onSnapshot(snap => {
          let results = []
          snap.docs.forEach(doc => {
            // must wait for the server to create the timestamp & send it back
            doc.data().createdAt && results.push({...doc.data(), id: doc.id})
          });
        }
          // update values
          posts.value = results;
        // 連接至posts的collection，並且取得資料，回傳的結果是物件，await等待資料傳回來，再把物件傳給左邊的data變數，data會是一promise物件
       // console.log(data.doc);
       // posts.value = data.docs.map((doc) => {
          //console.log(doc.data()); // 每一document裡面的內容
          //return { ...doc.data(), id: doc.id }  // 每一document裡面的內容（內容裡不包含id），id是位於doc上，因此需要額外加上id
        //})
      }, err => {
      error.value = err.message
    }
     */
    watchEffect((onInvalidate) => {
      onInvalidate(() => unsub());
    });
  return { posts, error } // return 使得引入的component可以catch到裡面的變數value
}

export default getPosts;